import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { capitalFirstLetter } from "../utils";
import { useTranslation } from "react-i18next";

function FeatureList({ data }) {
  const dekstop = useMediaQuery("(min-width:600px)");

  const { t } = useTranslation();

  return (
    <Box sx={{ my: 6, display: "flex", justifyContent: "center" }}>
      <Stack direction="row" spacing={6}>
        <Stack spacing={1} sx={{ alignItems: "center" }}>
          <i className="fa-solid fa-couch" style={{ fontSize: dekstop ? 34 : 24, color: "#f5272b" }}></i>
          <Typography fontSize={dekstop ? 16 : 12}>
            {data?.seat} {t("seat")}
          </Typography>
        </Stack>
        <Stack spacing={1} sx={{ alignItems: "center" }}>
          <i className="fa-solid fa-briefcase" style={{ fontSize: dekstop ? 34 : 24, color: "#f5272b" }}></i>
          <Typography fontSize={dekstop ? 16 : 12}>
            {data?.carBoot} {t("trunk")}
          </Typography>
        </Stack>
        <Stack spacing={1} sx={{ alignItems: "center" }}>
          <i className="fa-brands fa-bluetooth" style={{ fontSize: dekstop ? 34 : 24, color: "#f5272b" }}></i>
          <Typography fontSize={dekstop ? 16 : 12}>{capitalFirstLetter(data?.bluetooth || "Yes")}</Typography>
        </Stack>
        <Stack spacing={1} sx={{ alignItems: "center" }}>
          <i className="fa-brands fa-usb" style={{ fontSize: dekstop ? 34 : 24, color: "#f5272b" }}></i>
          <Typography fontSize={dekstop ? 16 : 12}> {capitalFirstLetter(data?.usb || "Yes")}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default FeatureList;
